import api from './api';

export interface HeroBannerNote {
  text: string;
  visible: boolean;
  updatedBy: string | null;
  updatedAt: string;
}

export interface UpdateHeroBannerPayload {
  text?: string;
  visible?: boolean;
}

export const heroBannerService = {
  async get(): Promise<HeroBannerNote> {
    const { data } = await api.get<HeroBannerNote>('/hero-banner');
    return data;
  },

  async update(payload: UpdateHeroBannerPayload): Promise<HeroBannerNote> {
    const { data } = await api.patch<HeroBannerNote>('/hero-banner', payload);
    return data;
  },
};
